// Port de app/(tabs)/historico.tsx.
// Mesma tela de /justificativas (no nativo são duas abas distintas → remonta ao alternar).
import { Carregando } from "@/app/Carregando";
import { useIsFocused } from "@/navigation";
import { lazy } from "react";

const HomeScreen = lazy(() => import("@/screens/Justificativas"));

export default function Historico() {
  const focused = useIsFocused();
  return focused ? (
    <Carregando>
      <HomeScreen />
    </Carregando>
  ) : null;
}
